<template>
    <!-- 考勤管理 -->
    <div class="attendance_box animate__animated animate__fadeIn">
        <div class="attendance">
            <div class="wrap">
                <div class="tab" style="text-align: center;padding: 10px 0;">
                    <el-radio-group v-model="isLive">
                        <el-radio-button label="0">表格统计</el-radio-button>
                        <el-radio-button label="1">月份统计</el-radio-button>
                    </el-radio-group>
                </div>

                <div v-if="isLive == 1">
                    <div class="block">
                        <span class="demonstration">选择查看的月份：</span>
                        <el-date-picker v-model="date" align="right" type="month" placeholder="选择年月" @change="fnSelectDate"></el-date-picker>
                        <div class="search-btn export" @click="fnExportExcelAliyun"></div>
                    </div>
                    <div class="content">
                        <div class="column week">
                            <div class="item">周日</div>
                            <div class="item">周一</div>
                            <div class="item">周二</div>
                            <div class="item">周三</div>
                            <div class="item">周四</div>
                            <div class="item">周五</div>
                            <div class="item br-transparent">周六</div>
                        </div>
                        <div class="column days" style="background-color: rgba(29, 68, 149, 0.1);">
                            <div class="item" @click="fnSelectDayData(item)" v-for="item in tableData" :key="item.index">
                                <div class="date">{{ item.date }}</div>
                                <div class="tab" :class="item.isShow ? '' : 'visible'">
                                    <div class="person">
                                        <dt>到岗人数</dt>
                                        <dd :class="item.isShow ? '' : 'visible'">{{ item.countNum }}</dd>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-tooltip class="item" effect="light" content="上一月考勤" placement="right">
                        <div class="handle-btn" style="left: 0;border-bottom-right-radius: 5px;border-top-right-radius: 5px;" @click="fnLastMonth">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="下一月考勤" placement="left">
                        <div class="handle-btn" style="right: 0;border-bottom-left-radius: 5px;border-top-left-radius: 5px;" @click="fnNextMonth">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </el-tooltip>
                </div>
                <div v-else><AttendanceRecord></AttendanceRecord></div>

                <div class="dialog_attList" v-if="dialogTableVisible">
                    <el-dialog title="考勤详情列表" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="dialogTableVisible" center>
                        <div class="cont_list">
                            <div class="list_title">
                                <div class="title_item">姓名</div>
                                <div class="title_item">卡号</div>
                                <div class="title_item">所属部门</div>
                                <div class="title_item">所属职位</div>
                                <div class="title_item">打卡类型</div>
                                <div class="title_item">设备名称</div>
                                <div class="title_item">体温</div>
                                <div class="title_item">打卡时间</div>
                                <div class="title_item">是否上传</div>
                                <div class="title_item">详情</div>
                            </div>
                            <div class="list_boxes">
                                <div class="list_box">
                                    <div v-if="recordData">
                                        <div class="box_line" v-for="(item, index) in recordData" :key="index">
                                            <div class="list_item">{{ item.personnel_name }}</div>
                                            <div class="list_item">{{ item.card_no }}</div>
                                            <div class="list_item" :title="fnDepartmentFormat(item.department)">
                                                <span>{{ fnDepartmentFormat(item.department) }}</span>
                                            </div>
                                            <div class="list_item" :title="fnDepartmentFormat(item.position)">
                                                <span>{{ fnDepartmentFormat(item.position) }}</span>
                                            </div>
                                            <div class="list_item">{{ fnSignType(item.sign_type) }}</div>
                                            <div class="list_item">{{ accessEqptList[item.eqpt_id] }}</div>
                                            <div class="list_item">{{ item.temperature }}</div>
                                            <div class="list_item">{{ item.sign_date }}</div>
                                            <div class="list_item" :title="item.is_upload | fnUploadObjToText"><span>{{ item.is_upload | fnUploadObjToText }}</span></div>
                                            <div class="list_item">
                                                <div>
                                                    <div class="search-btn" @click="fnLookFace(item.real_time_face)"><span>查看人脸照</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div slot="footer" class="dialog-footer" align="center">
                            <el-pagination
                                background
                                class="pagination"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="pageSizes"
                                :page-size="pageSize"
                                :current-page="currentPage"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageTotal"
                            />
                            <div class="btn_line">
                                <div class="search-btn" @click="dialogTableVisible = false"><span>关闭</span></div>
                            </div>
                        </div>
                    </el-dialog>
                </div>
                <div class="dialog_face" v-if="realTimeFace">
                    <el-dialog title="实时人脸照" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="realTimeFace" center>
                        <img :src="realFaceUrl" />
                        <div slot="footer" class="dialog-footer">
                            <div class="btn_line">
                                <div class="search-btn" @click="realTimeFace = false"><span>关闭</span></div>
                            </div>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AttendanceRecord from './components/attendanceRecord';
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo } from '@/utils/auth';
import { Loading } from 'element-ui';
export default {
    components: {
        AttendanceRecord
    },
    data() {
        return {
            pageSize: APP.PAGE.LIMIT,
            pageSizes: APP.PAGE.SIZE_OPTION,
            currentPage: APP.PAGE.SKIP_PAGE,
            searchName: '',
            searchType: '',
            searchTeam: '',
            searchWork: '',
            pageTotal: 0,
            loadingInstance: null,
            downloadLoading: false,
            date: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
            dialogTableVisible: false,
            tableData: [],
            recordData: [],
            recordCount: 0,
            excelData: [],
            realTimeFace: false,
            realFaceUrl: '',
            userInfo: null,
            isLive: 0,
            checkDate: '', // 选择查看的日期
            accessEqptList: {}, // 考勤设备列表
            thisMonthData: [] // 当月考勤记录
        };
    },
    created() {
        this.fnInit();
    },
    methods: {
        fnInit() {
            this.userInfo = getUserInfo();
            this.fnComputedDate();
            this.fnGetAccessEqpt();
        },
        // 选择每页查看条数
        handleSizeChange(val) {
            this.pageSize = val;
            if (!this.checkDate) return;
            this.fnGetDayData(
                {
                    date: this.checkDate,
                    page: this.currentPage,
                    size: this.pageSize
                },
                res => {
                    this.recordCount = res.data.count;
                    this.recordData = res.data.query;
                    this.pageTotal = res.data.count;
                }
            );
        },
        // 翻页
        handleCurrentChange(val) {
            this.currentPage = val;
            if (!this.checkDate) return;
            this.fnGetDayData(
                {
                    date: this.checkDate,
                    page: this.currentPage,
                    size: this.pageSize
                },
                res => {
                    this.recordCount = res.data.count;
                    this.recordData = res.data.query;
                    this.pageTotal = res.data.count;
                }
            );
        },
        // 上一月
        fnLastMonth() {
            let _date = new Date(this.date);
            _date.setMonth(_date.getMonth() - 1);
            this.date = _date;
            this.fnComputedDate(this.date);
        },
        // 下一月
        fnNextMonth() {
            let _date = new Date(this.date);
            _date.setMonth(_date.getMonth() + 1);
            this.date = _date;
            this.fnComputedDate(this.date);
        },
        fnSelectDate() {
            this.fnComputedDate(this.date);
        },
        fnComputedDate(_dateTime) {
            let _myDate = _dateTime ? new Date(_dateTime) : new Date();
            let _days = []; // 存放当月数据
            let _monthDays = 0; // 每月总天数
            let _startWeek = 0; // 当月第一天星期几
            let _findMonth = _myDate.getMonth() + 1; // 查询的月份
            let _currYear = new Date().getFullYear(); // 当前年份
            let _currMonth = new Date().getMonth() + 1; // 当前月份
            let _currDay = new Date().getDate(); // 当前日
            this.date = _myDate.getFullYear() + '-' + APP.fnAddZero_public(_findMonth);
            if (_dateTime) {
                _myDate.setMonth(_findMonth);
                _myDate.setDate(0);
            }
            _monthDays = _myDate.getDate(); // 获取当月总天数
            _myDate.setDate(1); // 将日期设置为当月第一天
            _startWeek = _myDate.getDay(); // 获取每月起始日是周几
            while (_startWeek) {
                _days.push({
                    isShow: false,
                    countNum: 0
                });
                --_startWeek;
            }
            for (let i = 1; i <= _monthDays; i++) {
                let _isShow = true;
                if (_myDate.getFullYear() > _currYear) {
                    _isShow = false;
                }
                if (_myDate.getFullYear() == _currYear) {
                    if (_findMonth > _currMonth) {
                        _isShow = false;
                    }
                    if (_findMonth == _currMonth) {
                        if (i > _currDay) {
                            _isShow = false;
                        }
                    }
                }
                _days.push({
                    dateText: _myDate.getFullYear() + '年' + APP.fnAddZero_public(_findMonth) + '月' + APP.fnAddZero_public(i) + '日',
                    date: _findMonth + '月' + i + '日',
                    day: i,
                    countNum: 0,
                    isShow: _isShow,
                    dateTime: _myDate.getFullYear() + '-' + _findMonth + '-' + i
                });
            }
            this.tableData = _days;
            this.fnGetMonthCount();
        },
        // 获取某一天的考勤数据
        fnGetDayData(_obj, _cb) {
            request({
                url: 'attendance/getDayData',
                method: 'GET',
                params: _obj
            })
                .then(res => {
                    _cb && _cb(res);
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 查看选择日期数据
        fnSelectDayData(_data) {
            this.recordData = [];
            if (!_data.isShow) return;
            if (!_data.countNum) {
                this.dialogTableVisible = true;
                return;
            }
            this.checkDate = _data.dateTime;
            this.recordData = [];
            this.dialogTableVisible = true;
            this.currentPage = 1;
            this.fnGetDayData(
                {
                    date: _data.dateTime,
                    page: this.currentPage,
                    size: this.pageSize
                },
                res => {
                    this.recordCount = res.data.count;
                    this.recordData = res.data.query;
                    this.pageTotal = res.data.count;
                }
            );
        },
        // 打卡类型
        fnSignType(_type) {
            return APP.fnSignType(_type);
        },
        // 部门、职位去除#号
        fnDepartmentFormat(_text) {
            return APP.fnTeamFormat(_text);
        },
        // 查看人脸照
        fnLookFace(_url) {
            this.realFaceUrl = _url;
            this.realTimeFace = true;
        },
        // 获取每月考勤数据
        fnGetMonthCount() {
            let _myDate = new Date(this.date);
            _myDate.setMonth(_myDate.getMonth() + 1);
            _myDate.setDate(0);
            request({
                url: 'attendance/getMonthCount',
                method: 'GET',
                params: {
                    startDate: this.date + '-01',
                    endDate: this.date + '-' + _myDate.getDate()
                }
            })
                .then(res => {
                    this.tableData.forEach((_item, _index) => {
                        if (_item.isShow) {
                            this.tableData[_index]['countNum'] = res.data[_item.dateText];
                        }
                    });
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 获取考勤设备列表
        fnGetAccessEqpt() {
            request({
                url: 'accessEqpt/get',
                method: 'GET'
            })
                .then(res => {
                    let _data = res.data.query;
                    if (_data.length) {
                        for (let _key in _data) {
                            this.accessEqptList[_data[_key]['id']] = _data[_key]['name'];
                        }
                    }
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
		//导出excel 阿里云下载
        // fnExportExcelAliyun() {
        //   let _that = this;
        //   let _myDate = new Date(_that.date);
        //   _myDate.setMonth(_myDate.getMonth() + 1);
        //   _myDate.setDate(0);
        //   request({
        //     url: "getMonthXls",
        //     method: "GET",
        //     params: {
        //         startDate: _that.date + "-01",
        //         endDate: _that.date + "-" + _myDate.getDate()
        //     }
        //   })
        //     .then(res => {
        //         if(res.data){
        //             window.open(res.data+'?'+Math.random());
        //         }
        //     })
        //     .catch(err => {
        //         _that.$message.error(err.data);
        //     });
        // },
        //导出excel 阿里云下载
        fnExportExcelAliyun() {
            request({
                url: 'attendance/getStatisticsExcel',
                method: 'GET',
                params: {
                    month: this.date
                }
            })
                .then(res => {
                    if (res.data) {
                        window.open(res.data + '?' + Math.random());
                    }
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 导出excel
        fnExportExcel() {
            let _that = this;
            _that.thisMonthData = [];
            _that.loadingInstance = Loading.service({
                fullscreen: true,
                background: 'rgba(255,255,255,0.7)',
                spinner: 'el-icon-loading',
                text: '导出excel中，请不要关闭网页'
            });
            let _page = 1; // 初始页数
            let _size = 1000; // 查询条数
            let _myDate = new Date(_that.date);
            _myDate.setMonth(_myDate.getMonth() + 1);
            _myDate.setDate(0);
            _fn();
            // 查询当月考勤
            function _fn() {
                request({
                    url: 'attendance/getMonthData',
                    method: 'GET',
                    params: {
                        page: _page,
                        size: _size,
                        startDate: _that.date + '-01',
                        endDate: _that.date + '-' + _myDate.getDate()
                    }
                })
                    .then(res => {
                        if (res.data.query.length) {
                            if (_page === 1) {
                                _that.thisMonthData = res.data.query;
                            } else {
                                _that.thisMonthData = _that.thisMonthData.concat(res.data.query);
                            }
                            _page++;
                            _fn();
                        } else {
                            _that.fnSetExcelData();
                        }
                    })
                    .catch(err => {
                        _that.loadingInstance.close();
                        _that.$message.error(err.data);
                    });
            }
        },
        // 组装excel数据
        fnSetExcelData() {
            if (!this.thisMonthData) {
                this.loadingInstance.close();
                return;
            }
            let _excelData = [];
            let _countData = {};
            this.thisMonthData.forEach(_item => {
                let _needData = {
                    id: _item.id,
                    name: _item.personnel_name,
                    sex: _item.sex === APP.YES ? '男' : '女',
                    temperature: _item.temperature,
                    card_no: _item.card_no,
                    department: this.fnDepartmentFormat(_item.department),
                    position: this.fnDepartmentFormat(_item.position),
                    is_upload: APP.fnUploadObjToText(_item.is_upload),
                    sign_type: this.fnSignType(_item.sign_type),
                    eqpt_name: this.accessEqptList[_item.eqpt_id],
                    sign_date: _item.sign_date
                };
                if (_countData[_item.personnel_id]) {
                    _countData[_item.personnel_id].push(_needData);
                } else {
                    _countData[_item.personnel_id] = [_needData];
                }
            });
            for (let _key in _countData) {
                _excelData = _excelData.length ? _excelData.concat(_countData[_key]) : _countData[_key];
            }
            const { export_json_to_excel } = require('../../../vendor/Export2Excel.js');
            const tHeader = ['Id', '姓名', '性别', '体温', '识别卡卡号', '部门', '职位', '是否上传', '打卡类型', '设备名称', '打卡时间'];
            const filterVal = ['id', 'name', 'sex', 'temperature', 'card_no', 'department', 'position', 'is_upload', 'sign_type', 'eqpt_name', 'sign_date'];
            const data = APP.formatJson(filterVal, _excelData);
            const _filename = getUserInfo().name + '-' + this.date + '-' + '考勤记录';
            export_json_to_excel({
                header: tHeader,
                data,
                filename: _filename
            });
            this.loadingInstance.close();
        }
    }
};
</script>

<style lang="scss" scoped type="text/scss">
@import '~@/styles/mixin.scss';
.attendance_box {
    width: 1920px;
    height: 858px;
    position: relative;
    overflow: hidden;
    .attendance {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
.wrap {
    min-height: 100%;
    position: relative;
    @include flex-box($direction: column);
    .visible {
        opacity: 0;
    }
    .block {
        text-align: center;
        margin-bottom: 20px;
        @include flex-box(center, center);
        >>> .el-input__inner {
            width: 211px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background-color: rgba(49, 88, 128, 0.4);
            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }
            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }
            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }
            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }
        >>> .el-input__icon {
            color: rgba(77, 180, 244, 0.7);
        }
    }
    .content {
        width: 1800px;
        margin-left: 60px;
        padding-bottom: 20px;
        @include flex-item();
        @include flex-box($direction: column);
        @include fnScroll();
        overflow-x: hidden;
        .column {
            font-size: 0;
            border: 1px solid #1d4495;
            &.week {
                width: 1800px;
                height: 48px;
                border: none;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-color: rgba(29, 68, 149, 0.1);
                background-size: 100% 100%;
                @include flex-box(space-around);
            }
            &.days {
                @include flex-item();
                @include fnScroll();
            }
            &:first-of-type {
                border-bottom: 1px solid transparent;
            }
            .item {
                display: inline-block;
                width: 257px;
                font-size: 16px;
                text-align: center;
                line-height: 30px;
                border-right: 1px solid #1d4495;
                border-bottom: 1px solid #1d4495;
                padding: 10px;
                cursor: pointer;
                &:hover {
                    background-color: rgba(222, 222, 222, 0.3);
                }
                .date {
                    height: 30px;
                    color: #409eff;
                }
                .tab {
                    border: 1px dashed #dfe6ec;
                    border-radius: 3px;
                    padding: 20px;
                    .person {
                        display: inline-block;
                        border-left: 2px solid #67c23a;
                        margin-right: 10px;
                        @include flex-item();
                        dt {
                            font-size: 14px;
                            color: rgba(255, 255, 255, 0.8);
                            margin-left: 14px;
                        }
                        dd {
                            font-size: 30px;
                            color: #67c23a;
                            margin-left: 14px;
                        }
                    }
                    .label {
                        @include flex-box();
                        border-bottom: 1px solid #dfe6ec;
                        color: #409eff;
                        &:last-of-type {
                            border-bottom: 1px solid transparent;
                        }
                        .name {
                            @include flex-item();
                        }
                        .text {
                            @include flex-item();
                        }
                    }
                }
            }
            &.week {
                .item {
                    border: none;
                }
            }
        }
    }
}
.handle-btn {
    position: fixed;
    width: 22px;
    height: 100px;
    top: 50%;
    cursor: pointer;
    background-color: #606266;
    opacity: 0.8;
    color: #fff;
    font-size: 24px;
    line-height: 100px;
    @include prefixCss3(transition, all 0.3s);
}
.dialog_attList,
.dialog_face {
    >>> .el-dialog {
        width: 1500px;
        height: 740px;
        margin-top: 18vh !important;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-form-item__label {
        color: #4db4f4;
    }
    >>> .el-dialog__title {
        color: #4db4f4;
    }
    >>> .el-dialog__close {
        color: #4db4f4;
    }
    // 分页样式
    >>> .el-pagination {
        display: inline-block;
    }
    >>> .el-pagination__total {
        color: #439fe3;
        font-size: 14px !important;
    }
    >>> .el-input__inner {
        background-color: rgba(49, 88, 128, 0.5) !important;
        border: none !important;
        color: #439fe3 !important;
    }
    >>> .el-pagination__jump {
        color: #439fe3;
        font-size: 14px !important;
    }
    >>> .el-select__caret {
        color: #439fe3;
    }
    >>> .el-pagination.is-background .btn-prev {
        color: #439fe3;
        background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .btn-prev:disabled {
        color: #439fe3;
        background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .btn-next {
        color: #439fe3;
        background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .btn-next:disabled {
        color: #439fe3;
        background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .el-pager li {
        color: #439fe3;
        background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #50aaff !important;
        color: #091027;
    }
    // 按钮样式
    .btn_line {
        display: inline-block;
    }
    // 弹窗列表样式
    .cont_list {
        width: 1450px;
        height: 565px;
        color: #ffffff;
        font-size: 16px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);
        .list_title {
            color: #4db4f4;
            width: 1450px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);
            .title_item {
                height: 48px;
                @include flex-box(center, center);
                &:nth-child(1) {
                    width: 108px;
                    margin-right: 4px;
                    margin-left: 25px;
                }
                &:nth-child(2) {
                    width: 136px;
                    margin-right: 4px;
                }
                &:nth-child(3) {
                    width: 136px;
                    margin-right: 4px;
                }
                &:nth-child(4) {
                    width: 136px;
                    margin-right: 4px;
                }
                &:nth-child(5) {
                    width: 136px;
                    margin-right: 4px;
                }
                &:nth-child(6) {
                    width: 136px;
                    margin-right: 4px;
                }
                &:nth-child(7) {
                    width: 106px;
                    margin-right: 4px;
                }
                &:nth-child(8) {
                    width: 166px;
                    margin-right: 4px;
                }
                &:nth-child(9) {
                    width: 106px;
                    margin-right: 4px;
                }
                &:nth-child(10) {
                    width: 200px;
                    margin-right: 25px;
                }
            }
        }
        .list_boxes {
            width: 1400px;
            height: 500px;
            margin-left: 25px;
            position: relative;
            overflow: hidden;
            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;
                .box_line {
                    color: #4db4f4;
                    width: 1450px;
                    height: 70px;
                    margin-top: 5px;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);
                    &:hover {
                        background-color: rgba(49, 88, 128, 0.4);
                    }
                    .list_item {
                        height: 70px;
                        @include flex-box(center, center);
                        &:nth-child(1) {
                            width: 108px;
                            margin-right: 4px;
                        }
                        &:nth-child(2) {
                            width: 136px;
                            margin-right: 4px;
                        }
                        &:nth-child(3) {
                            width: 136px;
                            margin-right: 4px;
                        }
                        &:nth-child(4) {
                            width: 136px;
                            margin-right: 4px;
                        }
                        &:nth-child(5) {
                            width: 136px;
                            margin-right: 4px;
                        }
                        &:nth-child(6) {
                            width: 136px;
                            margin-right: 4px;
                        }
                        &:nth-child(7) {
                            width: 106px;
                            margin-right: 4px;
                        }
                        &:nth-child(8) {
                            width: 166px;
                            margin-right: 4px;
                        }
                        &:nth-child(9) {
                            width: 106px;
                            margin-right: 4px;
                        }
                        &:nth-child(10) {
                            width: 200px;
                        }
                        span {
                            text-align: center;
                            width: 100%;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        div {
                            @include flex-box(center, center);
                            .item_btn {
                                width: 120px;
                                height: 32px;
                                line-height: 32px;
                                margin: 0 2px;
                                font-size: 14px;
                                color: #ffffff;
                                border: none;
                                text-align: center;
                                cursor: pointer;
                                background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                background-size: 100% 100%;
                                @include flex-box(center, center);
                                span {
                                    margin-top: -2px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
.dialog_face {
    >>> .el-dialog {
        width: 420px;
        height: 605px;
        margin-top: 18vh !important;
    }
    >>> .el-dialog__body {
        @include flex-box(center, center);
    }
    // 按钮样式
    .btn_line {
        @include flex-box(center, center);
    }
    img {
        width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Attendance/attendanceDefault/index.vue